import { Link } from "react-router-dom";
import styled from "styled-components";

export const HeaderStyle = styled.header`
  background-color: white;
  width: 100%;
  background-color: white;
  margin: auto;
  position: fixed;
  z-index: 6;

  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-weight: 500;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  }

  .header-container img {
    margin-left: 1em;
    padding: 15px 0;
  }

  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    .header-container img {
      width: 215px;
      margin-left: 50px;
      padding: 15px 0;
    }

    .header-top {
      height: 8.5vh;
    }
  }
  /* #endregion DESKTOP */
`;

export const BurguerButtonStyle = styled.button`
  border: none;
  background-color: transparent;
  margin-right: 1em;
  cursor: pointer;

  ion-icon {
    color: #812990;
    font-size: 4em;
  }

  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    display: none;
  }
  /* #endregion DESKTOP */
`;

export const BtnAreaLogadaContainer = styled.div`
  display: none;
  .suporte-logado {
    display: none;
  }

  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    .suporte-logado {
      display: block;
    }

    display: flex;
    align-items: center;
    .supportLink {
      margin-right: 12em;
      padding: 12px 12px 12px 12px;

      .header-link {
        text-decoration: none;
        color: rgba(136, 48, 152, 1);
      }
    }
  }
  /* #endregion DESKTOP */
`;

export const BtnUserNameStyle = styled.div`
  display: none;
  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    margin-top: 0.8%;
    display: block;
    border: ${(props) => (props.open ? `#792783;` : `none;`)};
    position: fixed;
    right: 0;
    top: 0;
    border-radius: 3px;
    cursor: pointer;
    font-weight: 600;
    background: #792783;
    border: none;
    color: #fff;
    /* margin-top: 20px; */
    margin-right: 1%;
    padding: 12px 12px 12px 12px;

    .header-username {
      color: #fff;
    }

    .header-username > ion-icon {
      margin-left: 10px;
    }
    transition: ${(props) =>
      props.toggle ? `background-color 0.5s ease-in;` : `background-color 0.5s ease-out;`};

    .user-exit-link {
      display: ${(props) => (props.open ? `block;` : `none;`)};
      margin: 15%;
      letter-spacing: 0.2px;
      font-weight: 600;
      vertical-align: middle;
    }

    .user-exit-link a {
      text-decoration: none;
      color: white;
    }

    ion-icon {
      vertical-align: middle;
    }
  }
  /* #endregion DESKTOP */
`;

export const HeaderLinksStyle = styled.section`
  padding: 0.5em;
  display: ${(props) => (props.open ? `flex;` : `none;`)};
  flex-direction: ${(props) => (props.open ? `column;` : `none;`)};
  width: 100%;
  position: fixed;
  left: 0em;
  top: 0em;
  bottom: 0em;
  right: 0em;
  z-index: -1;
  padding-top: 8em;
  padding-bottom: 0px;
  background-color: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  .register {
    background-color: #792783;
    border-radius: 8px;
    color: #ffffff !important;
  }

  .header-link {
    color: #340040;
    font-weight: 600px;
    font-size: 15px;
    line-height: 24px;
    margin: 0.5em 1em 0em 1em;
    padding: 1em;
    text-align: left;
    color: #340040;
  }

  .button {
    background: #812990;
  }
  .btn-branco {
    background: #ffffff !important;
    color: #792783 !important;
    border: 1px solid #792783 !important;
  }

  .header-link {
    text-decoration: none;
  }

  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    .mobile {
      display: none;
    }
    .suporte {
      display: none;
    }

    background-color: transparent;
    box-shadow: none;

    position: static;
    display: flex;
    flex-direction: row;
    gap: 1.5rem;
    /* justify-content: space-around; */
    align-items: center;
    width: ${(props) => (props.logged ? `60%` : `30%`)};
    padding: 0px;
    margin-right: 8rem;
    z-index: 0;

    .line-mobile-links {
      display: none;
    }
    .header-link {
      color: rgba(136, 48, 152, 1);
    }
  }
  /* #endregion DESKTOP */
`;

export const LinkUserArea = styled(Link)`
  background: rgba(227, 175, 31, 1);

  @media (max-width: 1280px) {
    display: none;
  }
  border: none;
  color: #fff;
  :hover {
    color: #fff;
  }
`;

export const LogoStyle = styled.div`
  .logo-container-desktop {
    display: none;
  }

  .logo-container-mobile {
    display: flex;
    align-items: center;

    img {
      width: 10rem;
    }
  }

  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    .logo-container-desktop {
      display: flex;
      align-items: center;
    }

    .logo-container-mobile {
      display: none;
    }
  }
  /* #endregion DESKTOP */
`;

export const RegisterMobile = styled.section`
  .register {
    padding: 1rem;
    background-color: #792783;
    border-radius: 6rem;
    color: #ffffff !important;
  }
  /* #region DESKTOP */
  /* 75rem é o equivalente a 1200px */
  @media (min-width: 75rem) {
    display: none;
    .register {
      display: none;
    }
  }
  /* #endregion DESKTOP */
`;
